import './polyfills.ts';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';

import { GlobalWindow } from './main.window';

declare let window: GlobalWindow;

console.log('Angular main.ts');

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function delay_start() {
  await sleep(0);
  try {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => {
        // console.error('BOOOOM');
        console.error(err);
      });
  } catch (err) {
    var node = document.getElementById('app-loading-error');
    if (node) {
      node.style.display = 'inherit';
    }
    var node = document.getElementById('app-loading-pending');
    if (node) {
      node.style.display = 'none';
    }

    throw err;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('*** Bootstrapping 1/2 ***');

  if (window.env == 'production') {
    enableProdMode();
  }

  // we delay the start so we can see animation while angular loads.
  delay_start();
});
